import React from 'react';
import Card from '@mui/material/Card';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import SearchIcon from '@mui/icons-material/Search';
import ChangelogRow from './ChangelogRow';
import styles from './changelog.module.css';
import { viewTypeIsMultiView, ViewTypes } from '../../core/datatypes/main';
import SearchBar from '../SearchBar';
import MenuIcon from '@mui/icons-material/Menu';

import { makeStyles } from '@mui/material/styles';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import Slide from '@mui/material/Slide';
import Button from '@mui/material/Button';
import InboxIcon from '@mui/icons-material/Inbox';
import DraftsIcon from '@mui/icons-material/Drafts';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';



interface ChangelogProps {
    data: Array<any>,
    view: ViewTypes
}



const Changelog = (props: ChangelogProps) => {
    const [changeLogSearchQuery, setChangeLogSearchQuery] = React.useState('');
    const [selectedIndex, setSelectedIndex] = React.useState(1);
    const [open, setOpen] = React.useState(false);

    const handleChangeLogsSearchQueryChange = (value: string) => {
        setChangeLogSearchQuery(value);
    };

    const changelogDataRows = new Array<any>(); 
    props.data.forEach(instance => {
        if (props.view === "traders-list") {            
            Object.keys(instance.historical_json).forEach(ts => {
                if (instance.historical_json[ts].prev_text !== 'None') {
                    changelogDataRows.push({
                        symbol: instance.symbol, 
                        ts: parseFloat(ts), 
                        ...instance.historical_json[ts]
                    })
                }
            })
        } else {
            Object.keys(instance.historical_json).forEach(ts => {
                if (instance.historical_json[ts].prev !== -2 ) { // don't show inits
                    changelogDataRows.push({
                        symbol: instance.symbol, 
                        timeframe: instance.timeframe, 
                        routing_key: instance.routing_key, 
                        ts: parseFloat(ts), 
                        ...instance.historical_json[ts]
                    });
                }
            })
        }
    }); 
    
    const changelogMarkup = changelogDataRows.sort((a,b) => b.ts - a.ts).map(row => {
        const key = (props.view === "traders-list") ? [row.symbol, row.ts.toString()].join('_') : [row.symbol, row.timeframe, row.routing_key, row.ts.toString()].join('_');
        if (changeLogSearchQuery && !row.symbol.includes(changeLogSearchQuery)) {
            return null;
        }
        return <ChangelogRow data={row} key={key}/>
    })

    const changelogComp = (changelogMarkup.length > 0) ? (changelogMarkup) : (
        <div className={styles.changelogRow} style={{width: '25vw'}}>
            No eligible changes
        </div>
    )
    
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const menuIsOpen = Boolean(anchorEl);
    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    let changeLogDrawerClassName = styles.changeLogDrawer;
    if (!open) {
        changeLogDrawerClassName += ` ${styles.changeLogDrawerHidden}`;
    }
    
    const iconButtonClassName = open ? '' : styles.leftIcon;
    
    const shouldShowSearchMenu = () => {
        // We decided to hide the search menu. Keep the functionality here so we can easily enable it again in the future
        return false;

        // return viewTypeIsMultiView(props.view)
    }

    return (
        <Card className={styles.changelog}>
            
            <div className={styles.changelogHeader}>
                {shouldShowSearchMenu() &&
                    <>
                        <IconButton className={iconButtonClassName} onClick={() => setOpen(!open)} aria-label="delete">
                            {open ? <ArrowBackIosIcon/> : <ArrowForwardIosIcon/> }
                        </IconButton>

                        <Slide timeout={5} direction="right" in={open} appear={false}>
                            <div className={changeLogDrawerClassName}>
                                <List component="nav" aria-label="main mailbox folders">
                                    <ListItem>
                                        <SearchBar onChange={handleChangeLogsSearchQueryChange} transformUppercase/>
                                    </ListItem>
                                </List>
                            </div>
                        </Slide>
                    </>
                }
                <span className={styles.changelogText}>Changelog</span>
            </div>
            <div className={styles.rowCont}>
                {changelogComp}
            </div>
        </Card>
    )
}

export default Changelog;